import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { gql, getUserCourseAccess } from '@yi/core';
import { i18n_or_purchase } from '@yi/i18n/phrases/i18n_or_purchase';
import { i18n_podcast } from '@yi/i18n/phrases/i18n_podcast';
import { i18n_premium_training } from '@yi/i18n/phrases/i18n_premium_training';
import { i18n_program } from '@yi/i18n/phrases/i18n_program';
import { i18n_purchase_this_content } from '@yi/i18n/phrases/i18n_purchase_this_content';
import { i18n_sign_in_or_create_to_access } from '@yi/i18n/phrases/i18n_sign_in_or_create_to_access';
import { i18n_sign_up } from '@yi/i18n/phrases/i18n_sign_up';
import { i18n_upgrade_to_membership } from '@yi/i18n/phrases/i18n_upgrade_to_membership';

import { useAccessTier } from '~/src/common/subscription';
import { useCurrentUser } from '~/src/common/user';

import { useLocale } from '../../LocaleProvider';

interface Props {
  permissions: Array<gql.typesClient.MembershipTier | null>;
  price: gql.typesClient.Fragment_CourseCard['a_la_carte_price'];
  categories: gql.typesClient.Fragment_CourseCard['categories'];
  course: gql.typesClient.Fragment_CourseCard;
  currentUser: gql.typesClient.Query_CurrentUser['CurrentUser'];
}

export const CourseAccessTip: React.FC<Props> = props => {
  const { tier: accessTier } = useAccessTier();
  // User has access, should not be shown access info
  if (getUserCourseAccess(props.currentUser, props.course, accessTier).hasAccess) return null;

  return <_CourseAccessTip {...props} />;
};

const _CourseAccessTip: React.FC<Props> = ({ permissions, price, categories }) => {
  let tooltip = '';
  const { locale } = useLocale();
  const { isLoggedIn } = useCurrentUser();
  const type = categories.find(cat => cat.id === '274')
    ? i18n_program(locale)
    : categories.find(cat => cat.id === '295')
    ? i18n_podcast(locale)
    : i18n_premium_training(locale);
  const hasAlacarte = !!price;
  const alacarteOnly = !permissions.length && hasAlacarte;
  const isFree = permissions.includes(gql.typesClient.MembershipTier.Free);
  const upgradeOrSignUp = isLoggedIn ? i18n_upgrade_to_membership(locale) : i18n_sign_up(locale);

  tooltip = isFree
    ? i18n_sign_in_or_create_to_access(locale, { type })
    : alacarteOnly
    ? i18n_purchase_this_content(locale, { type, price })
    : hasAlacarte
    ? `${upgradeOrSignUp} ${i18n_or_purchase(locale, {
        price,
        type,
      })}`
    : upgradeOrSignUp;

  return <LockOutlinedIcon titleAccess={tooltip} style={{ color: 'white' }} />;
};
